import { fetchApi } from "../../tools";


const request = async({...params}) => {
    const { contenido: content, url, headers, method } = params;
    const response = await fetchApi({
        url: url,
        method: method,
        headers: headers,
        content
    })
    return response;
}

export {
    request,
}
